<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chap-note" id="page2">Note</h2>
<p class="noindent">One of the most important virtues of an officer is credibility. A military organization supposedly cannot win a war without credibility along the chain of command. It is therefore assumed that most - surely not all - of the debriefs quoted in this presentation are credible; latter accounts from biographies, interviews and memoirs are therefore mostly ignored in this presentation of ILAF operations during Operation HOREV. Largely, this book is not a narrative, a story or a tale but a plain presentation of ILAF operations, mostly from an Israeli perspective, along the timeline of HOREV. It is not fully complete; it is not absolutely accurate; it is certainly concise and perhaps precise; but it is the best possible effort at this point in time.</p>
<p class="noindent">Shlomo Aloni</p>
<p class="noindent">1 November 2013</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Note.vue?7319225e